{
  // ── Shared helpers ───────────────────────────────────────────────────────

  const activateImage = (panel, handle) => {
    panel.querySelectorAll('.mega-menu__hero-img').forEach(img => {
      img.classList.toggle('is-active', img.dataset.handle === handle);
    });
  };

  const resetPanel = (panel) => {
    panel.querySelectorAll('.mega-menu__hero-img').forEach(img => img.classList.remove('is-active'));
    const first = panel.dataset.firstSwap;
    if (first) activateImage(panel, first);
  };

  // ── Desktop ──────────────────────────────────────────────────────────────

  const initDesktop = () => {
    if (window.innerWidth < 768) return;

    const nav = document.querySelector('.dh-header__nav, .custom-nav');
    if (!nav) { setTimeout(initDesktop, 100); return; }

    const megaItems = [...nav.querySelectorAll('.dh-nav__item--mega, .custom-nav__item--mega')];
    if (!megaItems.length) return;

    const pageheader = document.querySelector('.dh-header-section, #pageheader, .pageheader');
    if (!pageheader) return;

    const sharedPanel = document.createElement('div');
    sharedPanel.className = 'custom-nav__panel';
    sharedPanel.style.cssText = [
      'position:absolute', 'left:0', 'right:0', 'top:100%',
      'background:#fff',
      'color:#000',
      'border-top:1px solid rgba(0,0,0,0.06)',
      'box-shadow:0 12px 48px rgba(0,0,0,0.07)',
      'z-index:300',
      'overflow:hidden',
      'max-height:0',
      'pointer-events:none'
    ].join(';');

    if (getComputedStyle(pageheader).position === 'static') {
      pageheader.style.position = 'relative';
    }
    pageheader.appendChild(sharedPanel);

    const overlay = document.createElement('div');
    overlay.className = 'mega-overlay mega-overlay--menu';
    document.body.appendChild(overlay);

    let currentOpen = null;

    // ── Panel animation ───────────────────────────────────────────────────

    const openPanel = () => {
      sharedPanel.style.overflow  = 'visible';
      sharedPanel.style.maxHeight = 'none';
      const h = sharedPanel.scrollHeight || 300;
      sharedPanel.style.overflow   = 'hidden';
      sharedPanel.style.transition = 'none';
      sharedPanel.style.maxHeight  = '0px';
      sharedPanel.offsetHeight;
      sharedPanel.style.transition    = 'max-height 0.45s cubic-bezier(0.25,0.46,0.45,0.94)';
      sharedPanel.style.maxHeight     = h + 'px';
      sharedPanel.style.pointerEvents = 'auto';
      sharedPanel.addEventListener('transitionend', () => {
        if (sharedPanel.style.maxHeight !== '0px') {
          sharedPanel.style.maxHeight = 'none';
          sharedPanel.style.overflow  = 'visible';
        }
      }, { once: true });
    };

    const closePanel = () => {
      const h = sharedPanel.style.maxHeight === 'none'
        ? sharedPanel.scrollHeight + 'px'
        : sharedPanel.style.maxHeight;
      sharedPanel.style.overflow      = 'hidden';
      sharedPanel.style.pointerEvents = 'none';
      sharedPanel.style.transition    = 'none';
      sharedPanel.style.maxHeight     = h;
      sharedPanel.offsetHeight;
      sharedPanel.style.transition = 'max-height 0.4s cubic-bezier(0.25,0.46,0.45,0.94)';
      sharedPanel.style.maxHeight  = '0px';
    };

    // ── Content loading ───────────────────────────────────────────────────

    const loadContent = (item) => {
      const source = item.querySelector('.mega-menu--desktop');
      if (!source) return;
      const clone = source.cloneNode(true);
      clone.dataset.firstSwap = source.dataset.firstSwap || '';
      clone.removeAttribute('aria-hidden');
      clone.style.display = 'flex';
      clone.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
      clone.querySelectorAll('a').forEach(a => {
        a.style.color               = '#000';
        a.style.webkitTextFillColor = '#000';
        a.style.opacity             = '1';
        a.style.visibility          = 'visible';
        a.style.height              = 'auto';
        a.style.display             = 'block';
        a.style.fontSize            = '0.875rem';
        a.style.lineHeight          = '1.6';
        a.style.padding             = '0.25em 0';
        if (!a.textContent?.trim() && a.dataset.text) {
          a.textContent = a.dataset.text;
        }
      });
      resetPanel(clone);
      sharedPanel.innerHTML = '';
      sharedPanel.appendChild(clone);
    };

    sharedPanel.addEventListener('mouseenter', (e) => {
      const link = e.target.closest('[data-mega-swap]');
      if (!link) return;
      const panel = sharedPanel.querySelector('.mega-menu--desktop');
      if (panel) activateImage(panel, link.dataset.megaSwap);
    }, true);

    sharedPanel.addEventListener('mouseleave', (e) => {
      const link = e.target.closest('[data-mega-swap]');
      if (!link) return;
      const panel = sharedPanel.querySelector('.mega-menu--desktop');
      if (panel) resetPanel(panel);
    }, true);

    // ── Open / close ──────────────────────────────────────────────────────

    const open = (item) => {
      const isSwitch = currentOpen && currentOpen !== item;
      currentOpen = item;

      megaItems.forEach(mi => {
        mi.classList.toggle('custom-nav__item--inactive', mi !== item);
        mi.classList.toggle('dh-nav__item--inactive', mi !== item);
        mi.classList.toggle('mega-open', mi === item);
      });
      overlay.classList.add('is-visible');

      if (isSwitch) {
        const old = sharedPanel.firstElementChild;
        if (old) {
          old.style.transition = 'opacity 0.15s ease';
          old.style.opacity    = '0';
          setTimeout(() => {
            loadContent(item);
            const next = sharedPanel.firstElementChild;
            if (next) {
              next.style.opacity    = '0';
              next.style.transition = 'opacity 0.2s ease';
              next.offsetHeight;
              requestAnimationFrame(() => { next.style.opacity = '1'; });
            }
          }, 160);
        } else {
          loadContent(item);
        }
      } else {
        loadContent(item);
        openPanel();
      }
    };

    const close = () => {
      if (!currentOpen) return;
      currentOpen = null;
      closePanel();
      overlay.classList.remove('is-visible');
      megaItems.forEach(mi => {
        mi.classList.remove('custom-nav__item--inactive');
        mi.classList.remove('dh-nav__item--inactive');
        mi.classList.remove('mega-open');
      });
    };

    megaItems.forEach(item => {
      const link = item.querySelector('[data-mega-trigger]');
      if (!link) return;
      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentOpen === item) close();
        else open(item);
      });
    });

    overlay.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    window.addEventListener('scroll', close, { passive: true });
    document.addEventListener('click', (e) => {
      if (!currentOpen) return;
      if (sharedPanel.contains(e.target)) return;
      if (nav.contains(e.target)) return;
      close();
    });
  };


  // ── Mobile accordion helpers ─────────────────────────────────────────────

  const openAccordion = (panel) => {
    panel.style.transition = 'none';
    panel.style.maxHeight  = 'none';
    const h = panel.scrollHeight;
    panel.style.maxHeight  = '0px';
    panel.offsetHeight;
    panel.style.transition = 'max-height 0.65s cubic-bezier(0.16, 1, 0.3, 1)';
    panel.style.maxHeight  = h + 'px';
    panel.addEventListener('transitionend', () => {
      if (panel.style.maxHeight !== '0px') panel.style.maxHeight = 'none';
    }, { once: true });
  };

  const closeAccordion = (panel) => {
    panel.style.transition = 'none';
    panel.style.maxHeight  = panel.scrollHeight + 'px';
    panel.offsetHeight;
    panel.style.transition = 'max-height 0.45s cubic-bezier(0.4, 0, 0.2, 1)';
    panel.style.maxHeight  = '0px';
  };

  // ── Mobile country selector ──────────────────────────────────────────────

  const submitLocalization = (form, countryCode, languageCode, input) => {
    if (!form) return;
    if (input) input.value = languageCode;
    const hidden = document.createElement('input');
    hidden.type  = 'hidden';
    hidden.name  = 'country_code';
    hidden.value = countryCode;
    form.appendChild(hidden);
    form.submit();
  };

  const initCountrySelector = (drawer, closeAllMega) => {
    const sel = drawer.querySelector('.mobile-nav-country-selector');
    if (!sel) return;

    // Sub-language expand is handled entirely by the snippet's own script.
    // This function only wires the lang-btn submit and single-country submit
    // to avoid double-binding the has-langs accordion.

    sel.querySelectorAll('.mobile-nav-country-selector__lang-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const form  = document.getElementById('MobileNavLocalizationForm');
        const input = document.getElementById('MobileNavLanguageInput');
        submitLocalization(form, btn.value, btn.dataset.language || 'en', input);
      });
    });

    sel.querySelectorAll('.mobile-nav-country-selector__country-btn:not(.mobile-nav-country-selector__country-btn--has-langs)').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const form  = document.getElementById('MobileNavLocalizationForm');
        const input = document.getElementById('MobileNavLanguageInput');
        submitLocalization(form, btn.value, btn.dataset.language || 'en', input);
      });
    });
  };

  // ── Mobile drawer ────────────────────────────────────────────────────────

  const initMobileDrawer = (drawer) => {
    const megaItems = [...drawer.querySelectorAll('.navigation__item--custom-mega')];

    const closeAllMega = () => {
      megaItems.forEach(li => {
        if (!li.classList.contains('navigation__item--open')) return;
        const p = li.querySelector('.navigation__child-tier--mega');
        li._skip = true;
        li.classList.remove('navigation__item--open');
        if (p) closeAccordion(p);
        setTimeout(() => { li._skip = false; }, 100);
      });
    };

    megaItems.forEach(li => {
      const panel = li.querySelector('.navigation__child-tier--mega');
      if (!panel) return;
      new MutationObserver(() => {
        if (li._skip) return;
        if (li.classList.contains('navigation__item--open')) {
          megaItems.forEach(other => {
            if (other === li || !other.classList.contains('navigation__item--open')) return;
            const op = other.querySelector('.navigation__child-tier--mega');
            other._skip = true;
            other.classList.remove('navigation__item--open');
            if (op) closeAccordion(op);
            setTimeout(() => { other._skip = false; }, 100);
          });
          openAccordion(panel);
        } else {
          closeAccordion(panel);
        }
      }).observe(li, { attributes: true, attributeFilter: ['class'] });
    });

    new MutationObserver(() => {
      if (drawer.classList.contains('mobile-navigation-drawer--child-open') &&
          drawer.querySelector('.navigation__item--custom-mega.navigation__item--open')) {
        drawer.classList.remove('mobile-navigation-drawer--child-open');
        drawer.style.overflowY = 'auto';
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    initCountrySelector(drawer, closeAllMega);
  };

  const initMobile = () => {
    const setAnnouncementHeight = () => {
      const bar = document.querySelector('.section-announcement-bar');
      document.documentElement.style.setProperty('--announcement-bar-height', bar ? bar.offsetHeight + 'px' : '0px');
    };
    setAnnouncementHeight();
    window.addEventListener('resize', setAnnouncementHeight, { passive: true });

    new MutationObserver(() => {
      if (!document.body.classList.contains('reveal-mobile-nav')) {
        document.querySelectorAll('.navigation__item--custom-mega.navigation__item--open').forEach(li => {
          const p = li.querySelector('.navigation__child-tier--mega');
          li._skip = true;
          li.classList.remove('navigation__item--open');
          if (p) { p.style.transition = 'none'; p.style.maxHeight = '0px'; }
          setTimeout(() => { li._skip = false; }, 50);
        });
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('mobile-navigation-drawer')) initMobileDrawer(node);
        node.querySelectorAll?.('.mobile-navigation-drawer').forEach(initMobileDrawer);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.querySelectorAll('.mobile-navigation-drawer').forEach(initMobileDrawer);
  };

  // ── Desktop country selector ─────────────────────────────────────────────

  const initDesktopCountrySelector = () => {
    const trigger = document.getElementById('DesktopCountrySelector');
    const drawer  = document.getElementById('DesktopCountryDrawer');
    if (!trigger || !drawer) return;

    document.body.appendChild(drawer);

    const toggle   = trigger.querySelector('.desktop-country-selector__toggle');
    const closeBtn = drawer.querySelector('.desktop-country-drawer__close');
    const input    = document.getElementById('DesktopLanguageInput');
    const form     = drawer.querySelector('form');

    const drawerOverlay = document.createElement('div');
    drawerOverlay.className = 'mega-overlay mega-overlay--drawer';
    document.body.appendChild(drawerOverlay);

    const openDrawer = () => {
      drawer.removeAttribute('hidden');
      drawer.offsetHeight;
      drawer.classList.add('is-open');
      toggle?.setAttribute('aria-expanded', 'true');
      drawerOverlay.classList.add('is-visible');
      drawerOverlay.addEventListener('click', closeDrawer, { once: true });
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      drawerOverlay.classList.remove('is-visible');
      const onEnd = (e) => {
        if (e.target !== drawer) return;
        drawer.setAttribute('hidden', '');
        drawer.removeEventListener('transitionend', onEnd);
      };
      drawer.addEventListener('transitionend', onEnd);
    };

    toggle?.addEventListener('click', e => { e.stopPropagation(); drawer.hasAttribute('hidden') ? openDrawer() : closeDrawer(); });
    closeBtn?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) closeDrawer(); });

    drawer.querySelectorAll('.desktop-country-drawer__country-btn--has-langs').forEach(btn => {
      const list = btn.nextElementSibling;
      if (!list) return;
      list.style.cssText = 'max-height:0;overflow:hidden;transition:max-height 0.35s cubic-bezier(0.16,1,0.3,1)';
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        drawer.querySelectorAll('.desktop-country-drawer__country-btn--has-langs').forEach(b => {
          if (b !== btn) { b.setAttribute('aria-expanded', 'false'); if (b.nextElementSibling) b.nextElementSibling.style.maxHeight = '0px'; }
        });
        btn.setAttribute('aria-expanded', String(!isOpen));
        list.style.maxHeight = isOpen ? '0px' : list.scrollHeight + 'px';
      });
    });

    drawer.querySelectorAll('.desktop-country-drawer__lang-btn').forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); submitLocalization(form, btn.value, btn.dataset.language, input); });
    });
    drawer.querySelectorAll('.desktop-country-drawer__country-btn:not(.desktop-country-drawer__country-btn--has-langs)').forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); submitLocalization(form, btn.value, btn.dataset.language || 'en', input); });
    });
  };

  // ── Dehgraf custom mobile drawer ─────────────────────────────────────────

  const initDehgrafMobile = () => {
    const drawer  = document.getElementById('dh-mobile-drawer');
    const overlay = document.getElementById('dh-mobile-overlay');
    const toggle  = document.getElementById('dh-mobile-toggle');
    if (!drawer || !toggle) return;

    const setHeights = () => {
      const bar = document.querySelector('.section-announcement-bar');
      const hdr = document.querySelector('.dh-header-section');
      document.documentElement.style.setProperty('--announcement-bar-height', (bar?.getBoundingClientRect().height || 0) + 'px');
      document.documentElement.style.setProperty('--dh-header-height', (hdr?.getBoundingClientRect().height || 64) + 'px');
    };
    setHeights();
    window.addEventListener('resize', setHeights, { passive: true });

    const headerEl = document.querySelector('.dh-header-section');
    let isOpen = false;

    const closeCountrySheet = () => {
      if (window.__dhCloseCountrySheet) window.__dhCloseCountrySheet();
    };

    const openDrawer = () => {
      isOpen = true;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dh-mobile-open');
      headerEl?.classList.add('dh-header--inverted');
      headerEl?.classList.remove('dh-header--hidden');
      toggle.setAttribute('aria-expanded', 'true');
    };

    const closeDrawer = () => {
      isOpen = false;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dh-mobile-open');
      headerEl?.classList.remove('dh-header--inverted');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.querySelectorAll('.dh-mobile-nav__row--toggle[aria-expanded="true"]').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        const p = btn.closest('.dh-mobile-nav__item')?.querySelector('.dh-mobile-nav__panel');
        if (p) closeAccordion(p);
      });
      closeCountrySheet();
    };

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      /* If country sheet is open: close sheet only, stay in menu */
      if (window.__dhCountrySheetIsOpen && window.__dhCountrySheetIsOpen()) {
        closeCountrySheet();
        return;
      }
      isOpen ? closeDrawer() : openDrawer();
    });

    overlay?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen) closeDrawer(); });

    /* Close drawer on resize to desktop — handles devtools detach */
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768 && isOpen) closeDrawer();
    }, { passive: true });

    drawer.querySelectorAll('.dh-mobile-nav__row--toggle').forEach(btn => {
      const panel = btn.closest('.dh-mobile-nav__item')?.querySelector('.dh-mobile-nav__panel');
      if (!panel) return;
      panel.style.maxHeight = '0';
      panel.style.overflow  = 'hidden';

      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const panelOpen = btn.getAttribute('aria-expanded') === 'true';
        drawer.querySelectorAll('.dh-mobile-nav__row--toggle[aria-expanded="true"]').forEach(other => {
          if (other === btn) return;
          other.setAttribute('aria-expanded', 'false');
          const op = other.closest('.dh-mobile-nav__item')?.querySelector('.dh-mobile-nav__panel');
          if (op) closeAccordion(op);
        });
        btn.setAttribute('aria-expanded', String(!panelOpen));
        panelOpen ? closeAccordion(panel) : openAccordion(panel);
      });
    });

    initCountrySelector(drawer, () => {});
  };

  // ── Cart drawer trigger ───────────────────────────────────────────────

  const initCartTrigger = () => {
    const cartLink = document.querySelector('.dh-header__cart');
    if (!cartLink) return;
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: cartLink } }));
    });
  };

  // ── Cart count live update ───────────────────────────────────────────

  const initCartCountSync = () => {
    const countEl = document.querySelector('.dh-header__cart-count');
    if (!countEl) return;

    let requestToken = 0;
    let debounceTimer = null;

    const fetchAndUpdate = () => {
      const thisRequest = ++requestToken;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(res => { if (!res.ok) throw new Error(`/cart.js responded ${res.status}`); return res.json(); })
        .then(cart => {
          if (thisRequest !== requestToken) return;
          countEl.textContent = cart.item_count > 0 ? cart.item_count : '';
        })
        .catch(err => { if (thisRequest !== requestToken) return; console.warn('[mega-menu] cart count sync failed:', err); });
    };

    const scheduleUpdate = () => { clearTimeout(debounceTimer); debounceTimer = setTimeout(fetchAndUpdate, 120); };

    document.addEventListener('on:cart:after-merge', scheduleUpdate);
    document.addEventListener('on:cart:add', scheduleUpdate);
  };

  // ── Init ────────────────────────────────────────────────────────────────

  const init = () => {
    initDesktop();
    initMobile();
    initDehgrafMobile();
    initDesktopCountrySelector();
    initCartTrigger();
    initCartCountSync();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
}